import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getSurfaceTypesRequest } from "lib/api/reference/surfaceType";
import type { SurfaceTypeInterface } from "types/reference";

export const surfaceTypeReferenceKeys = {
    all: ["reference", "surface-type"] as const,
    list: (languageCode: string) => [...surfaceTypeReferenceKeys.all, "list", languageCode] as const,
};

export const fetchSurfaceTypes = (languageCode: string) =>
    parseResponse<Array<SurfaceTypeInterface>>(getSurfaceTypesRequest(languageCode));

export const surfaceTypeReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<SurfaceTypeInterface>>({
        queryKey: surfaceTypeReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchSurfaceTypes(languageCode),
        enabled: Boolean(languageCode),
    });

export const useSurfaceTypes = (languageCode: string) => useQuery(surfaceTypeReferenceQueryOptions(languageCode));
